<template>
  <div class="content" id="content">
    <div class="posi">
      当前位置： 首页 &nbsp;>>&nbsp; 学术与交流 &nbsp;>>&nbsp;
      <span>会议报名</span>
    </div>
    <div class="main">
      <div class="mainList">
        <p>会议报名</p>
        <ul>
          <li
            :class="{ posiLi: index === activeLiIdx }"
            v-for="(item, index) in liList"
            :key="index"
          >
            <p v-if="index === activeLiIdx"></p>
            {{ item.name }}
          </li>
        </ul>
        <button type="button" class="pay">线上缴费</button>
      </div>
      <div class="mainForm">
        <div class="verTitle">
          {{ liList[activeLiIdx].name }}
          <p></p>
        </div>
        <div v-show="activeLiIdx === 0">
          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-form-item prop="phone" label="手机">
              <el-input
                v-model="ruleForm1.phone"
                placeholder="请输入账号手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="mess" label="验证码">
              <el-input
                class="messageInput"
                v-model="ruleForm1.mess"
                placeholder="请输入短信验证码"
              ></el-input>
              <el-button type="text" class="sendOut">发送验证码</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="activeLiIdx === 1">
          <el-form
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleForm2"
            label-width="124px"
            id="demo-ruleForm"
          >
            <el-form-item label="作者：" prop="name">
              <el-input v-model="ruleForm2.name"></el-input>
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-input v-model="ruleForm2.sex"></el-input>
            </el-form-item>
            <el-form-item label="职务：" prop="duty">
              <el-input v-model="ruleForm2.duty"></el-input>
            </el-form-item>
            <el-form-item label="全国健康通行码：">
              <el-input placeholder="填写有或者无" v-model="ruleForm2.goodCode"></el-input>
            </el-form-item>
            <el-form-item label="学校：" prop="school">
              <el-input v-model="ruleForm2.school"></el-input>
            </el-form-item>
            <el-form-item label="学院：" prop="college">
              <el-input v-model="ruleForm2.college"></el-input>
            </el-form-item>
            <el-form-item label="部门：" prop="department">
              <el-input v-model="ruleForm2.department"></el-input>
            </el-form-item>
            <el-form-item label="系别：" prop="teacherLevel">
              <el-select v-model="ruleForm2.teacherLevel" placeholder="请选择">
                <el-option label="非一线教师" value="非一线教师"></el-option>
                <el-option label="一线教师" value="一线教师"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
              <el-input v-model="ruleForm2.email"></el-input>
            </el-form-item>
            <el-form-item label="住宿要求：" prop="accommodation">
              <el-select v-model="ruleForm2.accommodation" placeholder="请选择">
                <el-option label="合住" value="合住"></el-option>
                <el-option label="单位" value="单位"></el-option>
                <el-option label="不住宿" value="不住宿"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票类型：" prop="invoiceType">
              <el-select v-model="ruleForm2.invoiceType" placeholder="请选择">
                <el-option label="增值税专用" value="增值税专用"></el-option>
                <el-option label="普通" value="普通"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="发票抬头：" prop="invoiceTitle">
              <el-input v-model="ruleForm2.invoiceTitle"></el-input>
            </el-form-item>
            <el-form-item label="税号：" prop="invoiceNum">
              <el-input v-model="ruleForm2.invoiceNum"></el-input>
            </el-form-item>

            <el-form-item label="通讯地址：" prop="address">
              <el-input
                v-model="ruleForm2.address"
                placeholder="方便后期邮寄资料，请认真填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位电话：" prop="componyPhone">
              <el-input v-model="ruleForm2.componyPhone"></el-input>
            </el-form-item>
            <el-form-item label="银行账号：" prop="bankNum">
              <el-input v-model="ruleForm2.bankNum"></el-input>
            </el-form-item>
            <el-form-item label="开户信息：" prop="bankInfo">
              <el-input v-model="ruleForm2.bankInfo"></el-input>
            </el-form-item>
            <el-form-item label="去程时间：">
              <el-date-picker
                v-model="ruleForm2.goTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="返程时间：">
              <el-date-picker
                v-model="ruleForm2.backTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="备注：">
              <el-input v-model="ruleForm2.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="activeLiIdx === 2">
          <el-form
            :model="ruleForm3"
            :rules="rules3"
            ref="ruleForm3"
            label-width="106px"
            id="demo-ruleForm"
            class="webReg"
          >
            <el-form-item label="网站注册号：" prop="webNum">
              <el-input
                v-model="ruleForm3.webNum"
                placeholder="网站注册号通过微信扫描关注下方公众号后获取"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="qrCode">
                <img src="../assets/image/aboutUs.jpg" alt="" />
                <p>如您已关注“中国现代教育装备”微信公众号，请在公众号中</p>
                <p>回复数字“1”，获取网站注册号</p>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="textDiv" v-show="activeLiIdx === 3">
          <div class="text_img">
            <img src="../assets/image/back_img.png" alt="" />
            <p>提交成功</p>
          </div>
          <button class="back">返回首页</button>
        </div>
        <div class="next_back" style="width: 100%" v-if="activeLiIdx !== 3">
          <button class="next" @click="nextBtn">下一步</button>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    // 手机号校验规则
    let mobileValidata = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      }
      if (!/^1[0-9]{10}$/.test(value)) {
        callback(new Error("请输入正确的手机号码!"));
      }
      callback();
    };

    // 邮箱校验规则
    let emailValidata = (rule, value, callback) => {
      let emailTest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!emailTest.test(value)) {
        callback(new Error("请输入正确的邮箱!"));
      } else {
        callback();
      }
    };

    return {
      liList: [
        { name: "手机验证" },
        { name: "基本信息" },
        { name: "公众号验证" },
        { name: "报名成功" },
      ],
      ruleForm1: {
        phone: "",
        mess: "",
      },
      rules1: {
        phone: [
          {
            required: true,
            validator: mobileValidata,
            trigger: "blur",
          },
        ],
        mess: [
          {
            required: true,
            message: "请填写验证码",
            trigger: "blur",
          },
        ],
      },
      value1: "",
      value2: "",
      ruleForm2: {
        name: "",
        sex: "",
        duty: "",
        goodCode: "",
        school: "",
        college: "",
        department: "",
        teacherLevel: "",
        email: "",
        accommodation: "",
        invoiceType: "",
        invoiceTitle: "",
        invoiceNum: "",
        address: "",
        componyPhone: "",
        bankNum: "",
        bankInfo: "",
        goTime: "",
        backTime: "",
        remark: "",
      },
      rules2: {
        name: [
          {
            required: true,
            message: "请填写作者",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请填写性别",
            trigger: "blur",
          },
        ],
        duty: [
          {
            required: true,
            message: "请填写职务",
            trigger: "blur",
          },
        ],
        school: [
          {
            required: true,
            message: "请填写学校",
            trigger: "blur",
          },
        ],
        college: [
          {
            required: true,
            message: "请填写学院",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "请填写部门",
            trigger: "blur",
          },
        ],
        teacherLevel: [
          {
            required: true,
            message: "请选择系别",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            validator: emailValidata,
            trigger: "blur",
          },
        ],
        accommodation: [
          {
            required: true,
            message: "请选择住宿要求",
            trigger: "change",
          },
        ],
        invoiceType: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: "change",
          },
        ],
        invoiceTitle: [
          {
            required: true,
            message: "请填写发票抬头",
            trigger: "blur",
          },
        ],
        invoiceNum: [
          {
            required: true,
            message: "请填写税号",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写通讯地址",
            trigger: "blur",
          },
        ],
        bankNum: [
          {
            required: true,
            message: "请填写银行账号",
            trigger: "blur",
          },
        ],
        bankInfo: [
          {
            required: true,
            message: "请填写开户行信息",
            trigger: "blur",
          },
        ],
      },
      ruleForm3: {
        webNum: "",
      },
      rules3: {
        webNum: [
          {
            required: true,
            message: "请填写获取的网站注册号",
            trigger: "blur",
          },
        ],
      },
      activeLiIdx: 0, // 当前步骤
    };
  },
  methods: {
    nextBtn() {
      if (this.activeLiIdx >= 0 && this.activeLiIdx < 3) {
        if (this.activeLiIdx === 0) {
          this.$refs["ruleForm1"].validate((valid) => {
            if (valid) {
              this.activeLiIdx++;
            }
          });
        } else if (this.activeLiIdx === 1) {
          this.$refs["ruleForm2"].validate((valid) => {
            if (valid) {
              if (this.ruleForm2.goTime && this.ruleForm2.backTime) {
                let formattingGoTime = this.$moment(
                    this.ruleForm2.goTime
                  ).format("YYYY-MM-DD"),
                  formattingBackTime = this.$moment(
                    this.ruleForm2.backTime
                  ).format("YYYY-MM-DD"),
                  goTimeStamp = new Date(formattingGoTime).getTime(),
                  backTimeStamp = new Date(formattingBackTime).getTime();
                if (goTimeStamp > backTimeStamp) {
                  this.$message.warning("返程时间不能小于去程时间");
                  return false;
                } else {
                  this.activeLiIdx++;
                }
              } else {
                this.activeLiIdx++;
              }
            }
          });
        } else if (this.activeLiIdx === 2) {
          this.$refs["ruleForm3"].validate((valid) => {
            if (valid) {
              this.$http({
                url: "/api/conference",
                method: "post",
                data: this.$http.adornData({
                  phone: this.ruleForm1.phone,
                  name: this.ruleForm2.name,
                  sex: this.ruleForm2.sex,
                  duty: this.ruleForm2.duty, // 职务
                  goodCode: this.ruleForm2.goodCode, // 健康码
                  school: this.ruleForm2.school,
                  college: this.ruleForm2.college, // 学院
                  department: this.ruleForm2.department, // 部门
                  teacherLevel: this.ruleForm2.teacherLevel, // 系别
                  email: this.ruleForm2.email,
                  accommodation: this.ruleForm2.accommodation, // 住宿要求
                  invoiceType: this.ruleForm2.invoiceType, // 发票类型
                  invoiceTitle: this.ruleForm2.invoiceTitle, // 发票抬头
                  invoiceNum: this.ruleForm2.invoiceNum, // 税号
                  address: this.ruleForm2.address, // 通信地址
                  componyPhone: this.ruleForm2.componyPhone, // 单位电话
                  bankNum: this.ruleForm2.bankNum, // 银行卡号
                  bankInfo: this.ruleForm2.bankInfo, // 开户行信息
                  goTime: this.ruleForm2.goTime,
                  backTime: this.ruleForm2.backTime,
                  remark: this.ruleForm2.remark,
                  webNum: this.ruleForm3.webNum, // 网站注册号
                }),
              })
                .then((response) => {
                  let { code, msg } = response.data;
                  if (code === "1") {
                    this.activeLiIdx++;
                  } else {
                    this.$message.error(msg);
                    return false;
                  }
                })
                .catch((err) => this.$message.error(err));
            }
          });
        } else {
          this.activeLiIdx++;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 50px;
  min-height: 643px;
}

.mainList {
  width: 200px;
  height: 316px;
  border: 1px solid #e5e5e5;
  float: left;
}

.mainList p {
  height: 26px;
  line-height: 26px;
  padding-left: 40px;
  font-size: 26px;
  color: #333333;
  margin: 36px 0 40px 0;
}

.mainList ul {
  height: 215px;
  line-height: 50px;
  font-size: 16px;
}

.mainList ul li {
  padding-left: 38px;
}

.posiLi {
  color: #e20011;
  font-weight: bold;
  position: relative;
}

.posiLi p {
  width: 0;
  height: 0;
  border-top: 11px solid transparent;
  border-left: 12px solid #e20011;
  border-bottom: 11px solid transparent;
  position: absolute;
  left: 0;
  top: 50%;
  margin: -11px 0 0 0;
}

.successImg {
  color: #e20011;
  position: relative;
}

.successImg img {
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -10px;
}

.pay {
  width: 200px;
  height: 40px;
  background-color: #278dfe;
  font-size: 16px;
  color: #ffffff;
  border-radius: 5px;
  margin-top: 26px;
}

.mainForm {
  width: 721px;
  // min-height: 643px;
  float: right;
}

.mainForm .verTitle {
  height: 31px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 16px;
  font-weight: bold;
  padding-left: 9px;
  margin: 8px 0 50px 0;
}

.verTitle p {
  width: 40px;
  height: 3px;
  background-color: #e20011;
  margin: 7px 0 0 13px;
}

.messageInput {
  /* margin-left: 30px; */
  position: relative;
}

.sendOut {
  position: absolute;
  right: 20px;
}

.demo-ruleForm .el-form-item {
  width: 402px;
  margin: 0 auto 22px;
}

.demo-ruleForm .el-form-item__content {
  width: 402px;
  margin: 0 !important;
}

.next_back {
  width: 402px;
  height: 50px;
  margin-top: 47px;
  text-align: center;
}

.next_back button {
  width: 210px;
  height: 50px;
  font-size: 18px;
  background-color: #ffffff;
  border-radius: 5px;
}

.next_back /deep/ .next {
  background-color: #e20011;
  color: #ffffff;
}

.el-icon-date:before {
  content: "\e71f";
}

.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  margin-right: 16px;
}

.el-icon-arrow-up:before {
  content: "\e78f";
  color: #999999;
}

#demo-ruleForm {
  width: 525px;
  margin: auto;
}

#demo-ruleForm .el-input {
  width: 400px;
}

#demo-ruleForm .el-input--suffix {
  width: 220px;
}

#demo-ruleForm .el-form-item__label {
  width: 124px !important;
}

#demo-ruleForm .el-form-item__error {
  left: 13px;
}

.webReg .el-form-item__error {
  left: 25px !important;
}

.qrCode {
  width: 398px;
  height: 319px;
  border: 2px dashed #efefef;
  text-align: center;
  font-size: 14px;
  color: #cdcdcd;
  line-height: 36px;
  margin: 16px 0 0 0;
}

.qrCode img {
  width: 150px;
  height: 142px;
  margin-top: 50px;
}

.textDiv {
  min-height: 565px;
  margin-top: 154px;
}

.text_img {
  text-align: center;
}

.text_img p {
  margin-top: 40px;
  font-size: 24px;
  font-weight: bold;
  color: #278dfe;
}

.back {
  display: block;
  width: 208px;
  height: 48px;
  margin: 80px auto 118px;
  background-color: #ffffff;
  font-size: 17px;
  outline: none;
  border-radius: 5px;
  cursor: pointer;
  color: #666666;
  border: 1px solid #dcdcdc;
}
</style>
